import React, { useContext, useEffect } from "react";
import "./SignOut.scss";

import { useIonRouter } from "@ionic/react";
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";

const SignOut = (props: any) => {
  const router = useIonRouter();
  const { signOut } = useContext(AuthenticatedUserContext);

  useEffect(() => {
    signOut().then(() => {
      router.push("/");
      window.location.reload();
    });
  }, [signOut, router]);

  return <></>;
};

export default SignOut;
